export class PlannerConstants {
    public static readonly WEEKEND_VALUE = "/";
}
